var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/yes-we-can.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-10fd89d0!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/yes-we-can.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/YesWeCan.vue
// module id = 1377
// module chunks = 1